/**
 * @file action
 */
import * as Api from './api';
// common
export async function getTradeType({state, commit}, params) {
    return await Api.tradeTypeUrl(params);
}
// 1.菜单列表
export async function getMenuList({state, commit}, params) {
    const data = await Api.menuListUrl(params);
    commit('SET_MENU_LIST', data.data || [{}])
    return data;
}
// 首页-折线图
export async function getRegistryList({state, commit}, params) {
    return await Api.registryListUrl(params);
}
export async function getRegistryCount({state, commit}, params) {
    return await Api.registryCountUrl(params);
}


// 政策列表
export async function getPolicyList({state}, params) {
    return await Api.policyListUrl(params);
}
export async function getPolicyInfoTypeList({state}, params) {
    return await Api.policyInfoTypeListUrl(params);
}
// 政策详情
export async function getPolicyDetail({}, params) {
    return await Api.policyDetailUrl(params);
}
// 政策删除
export async function policyDel({}, params) {
    return await Api.policyDelUrl(params);
}
// 政策修改
export async function policyUpdate({}, params) {
    return await Api.policyUpdateUrl(params);
}



// 乡村项目审核列表
export async function getAuthList({}, params) {
    return await Api.authListUrl(params);
}

// 获取信息类型
export async function getInfoTypeList({}, params) {
    return await Api.infoTypeListUrl(params);
}
// 获取项目类型
export async function getProjectTypeList({}, params) {
    return await Api.projectTypeListUrl(params);
}
// 获取审核状态
export async function getStateList({}, params) {
    return await Api.stateListUrl(params);
}

// 文章详情
export async function getTextDetail({}, params) {
    return await Api.textDetailUrl(params);
}
// 项目修改
export async function authModify({}, params) {
    return await Api.authModifyUrl(params);
}
// 项目删除
export async function textDel({}, params) {
    return await Api.textDelUrl(params);
}


// 采购项目
export async function getResourceList({}, params) {
    return await Api.resourceListUrl(params);
}

export async function purInfoType({}, params) {
    return await Api.purInfoTypeListUrl(params);
}

// 文章详情
export async function getPurTextDetail({}, params) {
    return await Api.textPurDetailUrl(params);
}
// 项目修改
export async function resourceModify({}, params) {
    return await Api.resourceModifyUrl(params);
}
// 项目删除
export async function textResourceDel({}, params) {
    return await Api.textResourceDelUrl(params);
}




// 发布招标
export async function getBidList({}, params) {
    return await Api.bidListUrl(params);
}
export async function getReleaseBid({}, params) {
    return await Api.releaseBidUrl(params);
}
export async function updateBidStatus({}, params) {
    return await Api.updateBidStatusUrl(params);
}

export async function authType({}, params) {
    return await Api.authTypeUrl(params);
}



// 保函列表
export async function getLetterList({}, params) {
    return await Api.letterListUrl(params);
}
export async function updateLetter({}, params) {
    return await Api.updateLetterUrl(params);
}
export async function letterType({}, params) {
    return await Api.letterTypeUrl(params);
}

// 服务商
export async function purchaseApply({}, params) {
    return await Api.purchaseApplyUrl(params);
}

export async function mallDelete({}, params) {
    return await Api.mallDeleteUrl(params);
}

export async function mallList({}, params) {
    return await Api.mallListUrl(params);
}
export async function mallEdit({}, params) {
    return await Api.mallEditUrl(params);
}
export async function mallAdd({}, params) {
    return await Api.mallAddUrl(params);
}

// 轮播图列表
export async function getCarouseList({}, params) {
    return await Api.carouseListUrl(params);
}
// 轮播图新增
export async function carouseAdd({}, params) {
    return await Api.carouseAddUrl(params);
}
// // 轮播图上传
export async function carouseType({}, params) {
    return await Api.carouseTypeUrl(params);
}
// 轮播图修改
export async function carouseUpdate({}, params) {
    return await Api.carouseUpdateUrl(params);
}
// 轮播图删除
export async function carouseDel({}, params) {
    return await Api.carouseDelUrl(params);
}
// 轮播图状态
export async function photoStatus({}, params) {
    return await Api.photoStatusUrl(params);
}
// 启用禁用状态
export async function updateStatus({}, params) {
    return await Api.updateStatusUrl(params);
}
export async function vipType({}, params) {
    return await Api.vipTypeUrl(params);
}

// 用户模块
// 城市选择
export async function getCityList({state, commit}, params) {
    const data = await Api.cityListUrl(params);
    commit('SET_CITY_LIST', data.data || []);
    return data;
}
// 用户列表
export async function getUserList({state, commit}, params) {
    return await Api.userListUrl(params);
}
// 用户编辑
export async function updateUser({state, commit}, params) {
    return await Api.updateUserUrl(params);
}

// 跟进状态
export async function followType({state, commit}, params) {
    return await Api.followTypeUrl(params);
}

// 跟进状态
export async function purchaseFollowType({state, commit}, params) {
    return await Api.purchaseFollowTypeUrl(params);
}

// 项目融资
export async function financeList({state, commit}, params) {
    return await Api.financeListUrl(params);
}

export async function cycleType({state, commit}, params) {
    return await Api.cycleTypeUrl(params);
}

export async function moneyType({state, commit}, params) {
    return await Api.moneyTypeUrl(params);
}
export async function financeType({state, commit}, params) {
    return await Api.financeTypeUrl(params);
}
export async function orderStateType({state, commit}, params) {
    return await Api.orderStateTypeUrl(params);
}
export async function orderFollowUpdate({state, commit}, params) {
    return await Api.orderFollowUpdateUrl(params);
}


